import { EllipsisText, Flex, PageHeader } from '@shared/components';

import { EXAM_COURSE_LANGUAGE_TEXT, EXAM_COURSE_TYPE_TEXT } from '../../constants';
import { useExaminationCourse } from '../../providers';
import { ExaminationCourseNavigationTabs } from '../examination-course-navigation-tabs';

export default function ExaminationCourseHeader() {
  const { examinationCourse } = useExaminationCourse();
  const { name, code, type, language } = examinationCourse;

  return (
    <PageHeader
      title={name}
      subtitleSection={
        <Flex sx={(theme) => ({ gap: theme.spacing(4) })}>
          <EllipsisText variant='body2'>{`Exam Code: ${code}`}</EllipsisText>
          <EllipsisText variant='body2'>{`Course Type: ${EXAM_COURSE_TYPE_TEXT[type]}`}</EllipsisText>
          <EllipsisText variant='body2'>{`Course Language: ${EXAM_COURSE_LANGUAGE_TEXT[language]}`}</EllipsisText>
        </Flex>
      }
      tabs={<ExaminationCourseNavigationTabs />}
    />
  );
}
